import { render } from "./insure-bill.vue?vue&type=template&id=1d2a815a&scoped=true&ts=true"
import script from "./insure-bill.vue?vue&type=script&lang=ts"
export * from "./insure-bill.vue?vue&type=script&lang=ts"

import "./insure-bill.vue?vue&type=style&index=0&id=1d2a815a&lang=stylus&scoped=true"

import exportComponent from "E:\\code\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2a815a"]])

export default __exports__